import Nft from '/src/components/atoms/Nft' 
import * as React from 'react'

export default { Nft, React }